// Prerender readiness signal helpers.
//
// Emergent's crawler-cache (visible via `x-rendered-by: crawler-cache`
// response header) prerenders bot-facing HTML via a headless browser.
// Without an explicit ready signal it may snapshot the DOM before async
// data fetches finish, capturing the `<Loading…>` intermediate state OR
// a transient error fallback like "Content temporarily unavailable".
//
// Prerender contract (also enforced by the poll in /public/index.html):
//
//   window.prerenderReady = false  → keep waiting, do not snapshot
//   window.prerenderReady = true   → safe to snapshot the DOM
//
// Dynamic pages MUST call `signalPrerenderReady(status)` when loading
// reaches a terminal state. `status` is one of:
//
//   "ok"       — real content rendered. Safe to cache.
//   "notFound" — API returned 404. The <noindex> meta is already emitted;
//                safe to cache the "not found" page (Google/Bing tolerate
//                soft-404 signalling from SPAs).
//   "error"    — transient failure (network / 5xx / timeout). NEVER signal.
//                We deliberately leave the flag false so the crawler-cache
//                either waits (page recovers) or times out (does NOT cache
//                the fallback UI, so the next crawl can succeed cleanly).
//
// Legacy callers that call `signalPrerenderReady()` without arguments are
// treated as `"ok"` for backwards compatibility.
//
// See /app/docs/SEO_CONTENT_BIBLE.md §Prerender rules for the full contract.

export function signalPrerenderReady(status = "ok") {
  if (typeof window === "undefined") return;
  if (status === "error") return; // deliberately never flip the flag
  window.prerenderReady = true;
}
